module.exports = __webpack_public_path__ + "static/media/Sara_fromscratchorlibrary.548ec6cb.png";